import { render } from "./SpinnersPage.vue?vue&type=template&id=13fd7f9e&ts=true"
import script from "./SpinnersPage.vue?vue&type=script&lang=ts"
export * from "./SpinnersPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__